<template>
    <div class="modal" @keydown.esc="emitClose" id="calendarModal" tabindex="-1" role="dialog" aria-hidden="true">
        <div class="modal-dialog modal-lg modal-dialog-scrollable" role="document">
            <div class="modal-content">
                <div class="modal-header">
                    <h5 class="modal-title">Calendar</h5>
                    <button type="button" class="close" @click="closeModal" aria-label="Close">
                        <span aria-hidden="true">&times;</span>
                    </button>
                </div>
                <div class="modal-body">
                    <div class="row">
                        <div class="col-sm-12">
                            <student-calendar></student-calendar>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>

export default {
    name: "StudentCalendarModal",
    components: {},
    mounted() {
        $('#calendarModal').modal({backdrop: 'static'}).modal('show')
        setTimeout(function(){ $('[data-toggle="tooltip"]').tooltip({trigger: 'hover'}); }, 700);
    },
    data() {
        return {
        }
    },
    methods: {
        emitClose: function () {
            this.$emit('close')
        },
        closeModal: function () {
            this.emitClose()
            $('#calendarModal').modal('hide');
        },
    }
}
</script>

<style>

</style>
